module.exports = __webpack_public_path__ + "img/courtmatter_icon_white.bd7f6f56.svg";